import axios from "./configs/axiosConfig";

export const getTblProductsSearch = async (key) => {
  const url = `tblproducts/search?key=${key}`;
  return await axios.get(url);
};
